import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GlobalStyle } from './GlobalStyles';
import './index.css';

const { pathname, search, hash } = window.location;
if (pathname.length > 1 && pathname.endsWith('/')) {
  window.history.replaceState(null, '', pathname.replace(/\/+$/, '') + search + hash);
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>
);
